import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";
import { BrandLogo } from "@/components/Brand";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-6">
      <div className="bg-white border border-border rounded-3xl p-10 max-w-md w-full text-center animate-fade-up">
        <div className="flex justify-center mb-6">
          <BrandLogo className="h-11" />
        </div>
        <XCircle className="w-14 h-14 text-cappuccino mx-auto mb-5" />
        <h1 className="font-heading text-2xl font-bold text-ink mb-2" data-testid="payment-cancel">Assinatura cancelada</h1>
        <p className="text-cappuccino mb-6">Você cancelou o pagamento. Quando quiser, é só escolher um plano.</p>
        <Link to="/planos"><Button className="rounded-full bg-gold hover:bg-gold-hover text-white h-12 px-8 w-full">Voltar aos planos</Button></Link>
      </div>
    </div>
  );
}
